import { Swiper, SwiperSlide } from 'swiper/react'
import { A11y, Navigation, Pagination } from 'swiper/modules'
import CarouselCard, { CarouselCardVariant } from '../../search-spring-carousel/components/CarouselCard'
import { CarouselProduct, fromNative, fromSearchspring } from '../../search-spring-carousel/carouselProduct'

/* Where `products` came from, so the carousel knows how to map them onto a card. */
export type ProductCarouselSource = 'native' | 'searchspring' | 'normalized'

type Props = {
  enabledNavigation?: boolean
  enabledPagination?: boolean
  spaceBetween?: string | number
  slidesPerView?: number | 'auto'
  centerInsufficientSlides?: boolean
  loop?: boolean
  breakpoints?: any
  products: any
  source?: ProductCarouselSource
  classWrap?: string
  classSlider?: string
  profile?: string
  sku?: string
  cardVariant?: CarouselCardVariant
  /* Needed when the carousel starts out in a hidden container. */
  observer?: boolean
}

const normalizers: Record<ProductCarouselSource, (product: any) => CarouselProduct> = {
  native: fromNative,
  searchspring: fromSearchspring,
  normalized: (product: CarouselProduct) => product
}

const ProductCarousel = ({
  enabledNavigation = true,
  enabledPagination = false,
  spaceBetween = 0,
  slidesPerView = 4,
  centerInsufficientSlides = true,
  loop = false,
  breakpoints = {},
  products,
  source = 'native',
  classWrap = '',
  classSlider = '',
  sku = '',
  profile = '',
  cardVariant = 'default',
  observer = false
}: Props) => {
  const cards: CarouselProduct[] = products.map(normalizers[source])

  return (
    <div className={classWrap}>
      <Swiper
        modules={[A11y, Navigation, Pagination]}
        spaceBetween={spaceBetween}
        slidesPerView={slidesPerView}
        loop={loop}
        centerInsufficientSlides={centerInsufficientSlides}
        observer={observer}
        observeParents={observer}
        watchSlidesProgress
        navigation={enabledNavigation}
        pagination={{
          enabled: enabledPagination,
          clickable: true
        }}
        breakpoints={breakpoints}
      >
        {cards.map((product) => (
          <SwiperSlide key={product.id} className={classSlider}>
            <CarouselCard product={product} profile={profile} sku={sku} variant={cardVariant} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default ProductCarousel
